import { ArrowLeftOutlined } from "@ant-design/icons";
import Axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H6 } from "../../../../AbstractElements";
import madeInIndia from "../../../../assets/images/Frame 1.svg";
import secure from "../../../../assets/images/Frame 2.svg";
import logo from "../../../../assets/images/mdLogo.svg";
import image from "../../../../assets/images/Raj.jpg";

const OrganisationLogin = ({ selected }) => {
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [organisationName, setOrganisationName] = useState("");
  const [organisationType, setOrganisationType] = useState("studio");
  const [otp, setOtp] = useState("");
  const [state, setState] = useState("send");
  const [password, setPassword] = useState("test123");
  const [loading, setLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();
  const [resendOtp, setResendOtp] = useState(true);
  const [counter, setCounter] = useState(null);

  const [value, setValue] = useState(localStorage.getItem("token"));
  const [name, setName] = useState(localStorage.getItem("Name"));

  useEffect(() => {
    localStorage.setItem("token", value);
  }, [name, value]);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);


  const phoneNoTest = (no) => {
    const regexExp = /^[1-9]\d{9}$/gi;
    if (regexExp.test(no)) {
      return true;
    } else {
      return false;
    }
  };

  const sendOtp = (e) => {
    if (phoneNoTest(contact) === false) {
      return toast.error("Enter a valid phone number");
    }
    const values = new FormData();
    values.append("contact", contact);
    values.append("organisation_name", organisationName);
    values.append("organisation_type", organisationType);

    Axios.post(`apiV1/onboarding-register/`, values, {
      headers: {
        Authorization: "",
      },
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("OTP sent.");
          setState("verify");
          setCounter(29);
          return res.data;
        } else {
          toast.error("Something went wrong! Try again");
          return false;
        }
      })
      .catch((res) => {
        toast.error("Something went wrong! Try again");
        return false;
      });
  };

  useEffect(() => {
    if (otp?.toString().length === 6) {
      verifyOtp();
    }
  }, [otp]);

  const verifyOtp = (e) => {
    Axios.get(`apiV1/onboarding/?contact=${contact}&otp=${otp}`, {
      headers: {
        Authorization: "",
      },
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Logged in successfully!");
          setValue(res?.data?.token);
          localStorage.setItem("authenticated", true);
          window.location.href = `/app/project/project-list`;
          return res.data;
        } else {
          toast.error("Something went wrong! Try again");
          return false;
        }
      })
      .catch((res) => {
        toast.error("Invalid OTP! try again");
        return false;
      });
  };

  return (
    <Fragment>
      <section style={{ maxHeight: "100vh", overflowY: "hidden" }}>
        <Container fluid={true}>
          <Row>
            <Col xl="7 order-1">
              <div
                className={{}}
                style={{
                  backgroundImage: `url(${image})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  height: "100%",
                }}
              />
            </Col>
            <Col xl="5 p-0">
              <div className="login-card">
                <Form
                  className="theme-form login-form"
                  style={{ paddingBottom: "5px" }}
                >
                  <div style={{ textAlign: "center", paddingBottom: "20vh" }}>
                    <img src={logo} />
                  </div>
                  {state == "verify" ? (
                    <ArrowLeftOutlined
                      style={{
                        fontSize: "18px",
                        color: "#999",
                        cursor: "pointer",
                        paddingBottom: "10px",
                      }}
                      onClick={() => {
                        setState("send");
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <span
                    style={{
                      fontSize: "24px",
                      lineHeight: "24px",
                      fontWeight: "300",
                    }}
                  >
                    Sign in to
                    <span style={{ fontWeight: "600" }}> Material Depot</span>
                    <br></br> for Procurement.
                  </span>
                  <H6>Welcome back! Log in to your account.</H6>
                  <FormGroup>
                    <Label>Phone</Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        {/* <i className="icon-email"></i> */}
                        <i className="fa fa-phone"></i>
                      </span>
                      <Input
                        className="form-control"
                        type="number"
                        value={contact}
                        disabled={state == "verify"}
                        placeholder="Phone"
                        onChange={(e) => {
                          setContact(e.target.value);
                        }}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <Label>Organisation Name</Label>
                    <div className="input-group">
                      <Input
                        className="form-control"
                        type="organisation_name"
                        value={organisationName}
                        disabled={state == "verify"}
                        placeholder="Enter your organisation name"
                        onChange={(e) => {
                          setOrganisationName(e.target.value);
                        }}
                      />
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <Label for="exampleSelect">Organisation Type</Label>
                    <Input
                      type="select"
                      name="organisation_type"
                      id="organisation_type"
                      defaultValue={"studio"}
                      onChange={(e) => {
                        console.log(e.target.value);
                        setOrganisationType(e.target.value);
                      }}
                    >
                      <option value={"freelance"}>Freelancer</option>
                      <option value={"studio"}>Studio</option>
                      <option value={"enterprise"}>Enterprise</option>
                    </Input>
                  </FormGroup>
                  {state == "verify" && (
                    <FormGroup className="mb-1 !important">
                      <Label>OTP</Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="fa fa-unlock-alt"></i>
                        </span>
                        <Input
                          className="form-control"
                          type="number"
                          value={otp}
                          placeholder="OTP"
                          onChange={(e) => setOtp(e.target.value)}
                          onKeyDown={(e) => {
                            // e.preventDefault()
                            if (e.key === "Enter") {
                              e.preventDefault();
                              console.log("enter");
                              verifyOtp();
                            }
                          }}
                        />
                      </div>
                    </FormGroup>
                  )}
                  <FormGroup>
                    <Row>
                      <Col
                        xl="7 order-1"
                        sm="7"
                        md="7"
                        xs="5"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        {state == "verify" && counter ? (
                          <span
                            style={{
                              marginBottom: "5px",
                              fontSize: "14px",
                              marginBottom: "0px",
                              color: "#999",
                            }}
                          >
                            {" "}
                            Resend OTP in 00:{counter}
                          </span>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col xl="5 order-1" sm="5" md="5"></Col>

                      <Col xl="7 order-1" sm="7" md="7" className="pb-1">
                        {state == "verify" ? (
                          <Btn
                            attrBtn={{
                              color: "primary",
                              className: "btn-block",
                              disabled: counter ? true : false,
                              onClick: (e) => {
                                setOtp("");
                                sendOtp();
                              },
                            }}
                          >
                            Resend OTP
                          </Btn>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col xl="5 order-1" sm="5" md="5">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn-block",
                            disabled: loading ? loading : loading,
                            onClick: (e) => {
                              state == "send" ? sendOtp() : verifyOtp();
                            },
                          }}
                        >
                          {state == "send" ? "Send OTP" : "Submit"}
                        </Btn>
                      </Col>
                    </Row>
                  </FormGroup>
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        display: "flex",
                        paddingTop: "5vh",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={madeInIndia}
                        style={{ height: "100px", width: "100px" }}
                      />
                      <img
                        src={secure}
                        style={{ height: "100px", width: "100px" }}
                      />
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default OrganisationLogin;
